import OriginInfoList from '@/data/originInfo/view/list.vue'
import OriginInfoEditor from '@/data/originInfo/view/editor.vue'
import sortableListView from '@/data/originInfo/view/list-sortable.vue'

const list = {
  path: '/originInfo',
  name: 'originInfo-list',
  component: OriginInfoList
}
const creator = {
  path: '/originInfo/creator',
  name: 'createOriginInfo',
  component: OriginInfoEditor
}
const editor = {
  path: '/originInfo/editor/:id(\\d+)',
  name: 'updateOriginInfo',
  component: OriginInfoEditor
}

const sortableList = {
  path: '/originInfo/sorting',
  name: 'originInfo-list-sortable',
  component: sortableListView
}

export default [list, creator, editor, sortableList]
